import { render, staticRenderFns } from "./LinkIndex.vue?vue&type=template&id=2ccbae09&scoped=true"
import script from "./LinkIndex.vue?vue&type=script&lang=js"
export * from "./LinkIndex.vue?vue&type=script&lang=js"
import style0 from "./LinkIndex.vue?vue&type=style&index=0&id=2ccbae09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbae09",
  null
  
)

export default component.exports